import Cookies from 'js-cookie';
import { addToCartFetcher } from '../datafetchers/productPage';
import { getUserIsLoggedIn } from './helper';

export const addCartHandler = async (productId, isDealProduct = false) => {
  const webUserId = Cookies.get('web_user_id_react');
  const params = {
    product: productId,
    login: getUserIsLoggedIn(),
    add_quantity: false,
    less_quantity: true,
    web_user_id: webUserId,
    dealPriceProduct: isDealProduct,
  };
  const addToCartApiData = await addToCartFetcher(params);
  return addToCartApiData?.success;
};
